/**
 * Toast Component
 *
 * Lightweight toast notification for auto-save feedback
 * Appears bottom-right with slide-in animation
 * Auto-dismisses after duration
 */

import { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose, duration = 2000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const colors = {
    success: {
      bg: '#dcfce7',
      border: '#22c55e',
      text: '#14532d',
      icon: '✓'
    },
    error: {
      bg: '#fee2e2',
      border: '#ef4444',
      text: '#dc2626',
      icon: '✕'
    },
    info: {
      bg: '#dbeafe',
      border: '#3b82f6',
      text: '#1e40af',
      icon: 'ℹ'
    }
  };

  const style = colors[type] || colors.success;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        padding: '12px 20px',
        background: style.bg,
        border: `2px solid ${style.border}`,
        borderRadius: '8px',
        color: style.text,
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        animation: 'slideInRight 0.3s ease-out',
        maxWidth: '400px'
      }}
    >
      <span style={{
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        background: style.border,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: '700',
        flexShrink: 0
      }}>
        {style.icon}
      </span>
      <span>{message}</span>
      <button
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          color: style.text,
          fontSize: '18px',
          cursor: 'pointer',
          padding: '0 4px',
          marginLeft: '8px',
          opacity: 0.6,
          transition: 'opacity 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.opacity = '1'}
        onMouseLeave={(e) => e.target.style.opacity = '0.6'}
      >
        ×
      </button>
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(400px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}
